import { Grid, IconButton, Tooltip } from '@mui/material'
import { useCallback, useEffect, useState } from 'react'
import { MdAdd, MdArrowBack } from 'react-icons/md'
import Programa from '../../../components/Programa/Programa'
import { metodoPrograma } from '../../../components/api'
import EdicaoFornecedor from './EdicaoFornecedor'
import PrimeTable from '../../../components/PrimeTable'

const Fornecedor = () => {
  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [dados, setDados] = useState(null)
  const [refresh, setRefresh] = useState(0)

  const exclui = useCallback((dados) => {
    metodoPrograma('exclui', { idFornecedor: dados[0] }).then((res) => {
      if (res.status) {
        setRefresh((prev) => prev + 1)
      }
    })
  }, [])

  const handleClick = (linha) => {
    setDados(linha)
    setTela('opcoes')
  }

  const voltar = () => {
    setDados(null)
    setTela('lista')
  }

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <Tooltip title="Adicionar">
            <IconButton onClick={() => setTela('opcoes')}>
              <MdAdd />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'opcoes':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      default:
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tela])

  return (
    <Programa codigo="CtrlFornecedor" ferramentas={ferramentas}>
      {tela === 'opcoes' ? (
        <EdicaoFornecedor {...{ dados, voltar, setTela }} />
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid item xs={12}>
              <PrimeTable
                codigo="CtrlFornecedor"
                action="lista"
                rows={10}
                habSearch
                head={['Nome', 'Telefone', 'Email', 'Exclusão']}
                line={(item) => [item[1], item[4], item[5], item[3]]}
                collumnsDateHour={[3]}
                onRowSelect={handleClick}
                onDelete={{ index: 3, action: exclui }}
                refresh={refresh}
              />
            </Grid>
          </Grid>
        </Grid>
      )}
    </Programa>
  )
}

export default Fornecedor
